// extracted by mini-css-extract-plugin
export default {"contentContainer":"versions_contentContainer__inAXA"};